import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { apiEndpoints } from '../endpoints';
import { queryKeys } from '../react-query.config';
import { toast } from 'sonner';

interface MarkAsPaidOutParams {
  pickemId: string;
}

export async function markAsPaidOut({ pickemId }: MarkAsPaidOutParams) {
  const response = await api.post(apiEndpoints.markAsPaidOut(pickemId));
  return response.data;
}

export function useMarkAsPaidOutMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: markAsPaidOut,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.pickems.all });
      toast.success('Pickem marked as paid out');

      // Reload the page after a short delay to show the toast
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    onError: (error: any) => {
      const errorData = error?.response?.data;
      let errorMessage = errorData?.error || 'Failed to mark pickem as paid out';

      if (errorData?.current_status) {
        errorMessage = `${errorMessage} (Current status: ${errorData.current_status})`;
      }

      toast.error(errorMessage);
    },
  });
}
